module.exports = __webpack_public_path__ + "assets/img/5f14abcb710ff0d98381ecc1672aaa9f.png";